import React, { useRef, useEffect } from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import InputBase from '@material-ui/core/InputBase';

const CssTextField = withStyles((theme) => ({
  input: {
    backgroundColor: theme.palette.common.white,
    border: '1px solid #E4E4E4',
    borderRadius: 4,
    padding: '14px 12px',
    '&:focus': {
      // boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

function Input({ name, ...rest }) {
  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <CssTextField
      id={fieldName}
      inputRef={inputRef}
      defaultValue={defaultValue}
      error={error !== undefined}
      // helperText={error}
      {...rest}
    />
  );
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Input;
